export { default as Tabs } from "./tabs";
export { default as Tab } from "./tab";
export { default as TabList } from "./tabList";
export { default as TabPanel } from "./tabPanel";
